import PropTypes from "prop-types";
import React from "react";
import Radio from "app/pages/.shared/form/Radio";
import { DEPOSIT_LOT2_COUNTRIES, PAYMENT_OPTIONS } from "app/constants";
import AmountContainer from "app/pages/.shared/AmountContainer";
import "./PaymentModesFieldset.scss";
import { FormattedDate, FormattedMessage } from "react-intl";
import { determineCardType } from "app/utils/creditCardUtils";
import IconPaiement4x from "app/pages/.shared/static/icons/IconPaiement4x";
import IconPaiement2x from "app/pages/.shared/static/icons/IconPaiement2x";
import IconPaiementComptant from "app/pages/.shared/static/icons/IconPaiementComptant";
import IconDeposit from "app/pages/.shared/static/icons/IconDeposit";

class PaymentModesFieldset extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			cardType:
				typeof window !== "undefined"
					? determineCardType(props.creditCardNumber) // adyen ne doit pas etre appele cote server side
					: undefined,
		};
	}

	componentWillReceiveProps(nextProps) {
		const { creditCardNumber } = this.props;
		const nextCreditCardNumber = nextProps.creditCardNumber;

		if (nextCreditCardNumber !== creditCardNumber) {
			this.setState({
				cardType: determineCardType(nextCreditCardNumber),
			});
		}
	}

	render() {
		const {
			total,
			field,
			onChange,
			mensualite2Fois,
			paymentModes,
			casino,
			isDepositEnabled,
			isBookingEligibleForDeposit,
			isPaiementPledg4xAvailable,
			shop = "",
		} = this.props;
		const { cardType } = this.state;

		const [lang, country] = shop && shop.split("-");

		const paymentDepositOptionSublabel =
			(isBookingEligibleForDeposit || DEPOSIT_LOT2_COUNTRIES.includes(country)) &&
			lang !== "fr"
				? "payment.methods.deposit.label.simple.1"
				: "payment.methods.deposit.label.simple.1.b";

		return (
			<div className="payment-options__items">
				{paymentModes
					.filter(paymentMode => {
						if (paymentMode === PAYMENT_OPTIONS["2x"] && isDepositEnabled) {
							return isBookingEligibleForDeposit;
						}

						return true;
					})
					.map((paymentMode, index) => {
						const isPaymentCasino = paymentMode === PAYMENT_OPTIONS["4x"];

						const isPaymentCasinoNotAllowedWithAmex =
							cardType === "amex" && isPaymentCasino;

						const isPayment4xNotAllowed = isPaymentCasino && casino.forbiddenCause;

						let headerComponent = false;
						const radioValue = paymentMode;
						const ispaymentModeselected =
							field.value === (radioValue && radioValue.toString());

						if (paymentMode === PAYMENT_OPTIONS["1x"]) {
							headerComponent = (
								<div className="payment-options__line">
									<div className="payment-options__icon">
										<IconPaiementComptant
											className="icon"
											width={30}
											height={20}
										/>
									</div>
									<div className="payment-options__label">
										<FormattedMessage id="payment.methods.full.label.simple" />
									</div>
									<div className="payment-options__pay-now-amount">
										<AmountContainer amount={total} />
									</div>
								</div>
							);
						} else if (paymentMode === PAYMENT_OPTIONS["2x"]) {
							headerComponent = (
								<div className="payment-options__line">
									<div>
										<div className="payment-options__line">
											<div className="payment-options__icon">
												{isBookingEligibleForDeposit ||
												DEPOSIT_LOT2_COUNTRIES.includes(country) ? (
													<IconDeposit width={42} height={40} />
												) : (
													<IconPaiement2x width={35} height={25} />
												)}
											</div>
											<div className="payment-options__label">
												{isBookingEligibleForDeposit ||
												DEPOSIT_LOT2_COUNTRIES.includes(country) ? (
													<FormattedMessage id="payment.methods.deposit.label" />
												) : (
													<FormattedMessage id="payment.methods.2x.withoutfees.label" />
												)}
											</div>
										</div>
										<div className="payment-options__line">
											<div className="payment-options__sublabel">
												<FormattedMessage
													id={
														isBookingEligibleForDeposit ||
														DEPOSIT_LOT2_COUNTRIES.includes(country)
															? paymentDepositOptionSublabel
															: "payment.methods.partial.label.simple.1"
													}
													tagName="div"
													values={{
														percentage:
															mensualite2Fois.percentagePayNow,
														amountToPayNow: (
															<AmountContainer
																amount={
																	mensualite2Fois.payNowAmount
																}
															/>
														),
													}}
												/>
												<FormattedMessage
													id={"payment.methods.partial.label.simple.2"}
													tagName="div"
													values={{
														solde: (
															<AmountContainer
																amount={
																	mensualite2Fois.payLaterAmount
																}
															/>
														),
														date: (
															<span className="payment-options__date">
																<FormattedDate
																	timeZone="UTC"
																	day="2-digit"
																	month="2-digit"
																	year="numeric"
																	value={mensualite2Fois.dueDate}
																/>
															</span>
														),
													}}
												/>
											</div>
										</div>
									</div>
									<div className="payment-options__pay-now-amount">
										<AmountContainer amount={mensualite2Fois.payNowAmount} />
									</div>
								</div>
							);
						} else if (isPaymentCasino) {
							headerComponent = (
								<div className="payment-options__line">
									<div>
										<div className="payment-options__line">
											<div className="payment-options__icon">
												<IconPaiement4x
													className="icon"
													width={30}
													height={20}
												/>
											</div>
											<div className="payment-options__label">
												<FormattedMessage
													id="payment.methods.casino.label.simple"
													values={{
														sansFrais: !casino.mensualiteCasino
															.coutCredit && (
															<FormattedMessage id="general.sans.frais" />
														),
													}}
												/>
												{!isPaiementPledg4xAvailable && "*"}
											</div>
										</div>
										<div className="payment-options__line">
											<div className="payment-options__sublabel">
												{casino.mensualiteCasino.coutCredit > 0 ? (
													<FormattedMessage
														id="payment.methods.casino.label.simple.2"
														values={{
															mensualites: (
																<div className="payment-options__mensualites">
																	(1 x{" "}
																	<AmountContainer
																		amount={
																			casino.mensualiteCasino
																				.apport
																		}
																	/>
																	) + (3 x{" "}
																	<AmountContainer
																		amount={
																			casino.mensualiteCasino
																				.mensualite
																		}
																	/>
																	)
																</div>
															),
															frais: (
																<AmountContainer
																	amount={
																		casino.mensualiteCasino
																			.coutCredit
																	}
																/>
															),
														}}
													/>
												) : (
													<FormattedMessage
														id="payment.methods.casino.label.simple.sans.frais.2"
														values={{
															mensualites: (
																<div className="payment-options__mensualites">
																	(1 x{" "}
																	<AmountContainer
																		amount={
																			casino.mensualiteCasino
																				.apport
																		}
																	/>
																	) + (3 x{" "}
																	<AmountContainer
																		amount={
																			casino.mensualiteCasino
																				.mensualite
																		}
																	/>
																	)
																</div>
															),
														}}
													/>
												)}
											</div>
										</div>
									</div>
									<div className="payment-options__pay-now-amount">
										<AmountContainer amount={casino.mensualiteCasino.apport} />
									</div>
								</div>
							);
						}
						return (
							<div className="payment-options__item" key={index}>
								{isPayment4xNotAllowed && (
									<div className="payment-options__note">
										{casino.forbiddenCause}
									</div>
								)}

								{isPaymentCasinoNotAllowedWithAmex && (
									<div className="payment-options__note">
										<FormattedMessage id="error.payment.external.amex.not.supported" />
									</div>
								)}

								<Radio
									field={field}
									showIcon={true}
									disabled={
										isPayment4xNotAllowed || isPaymentCasinoNotAllowedWithAmex
											? true
											: false
									}
									name={`payment-mode-${radioValue}`}
									id={`payment-mode-${radioValue}`}
									value={radioValue}
									checked={ispaymentModeselected}
									toggle={() => {
										onChange(radioValue);
									}}
									data-cy={`payment-mode-${radioValue}`}
								>
									<div className="payment-options__content">
										{headerComponent}
									</div>
								</Radio>
							</div>
						);
					})}
			</div>
		);
	}
}

PaymentModesFieldset.defaultProps = {
	total: 0,
	field: {},
	mensualite2Fois: {},
	paymentModes: [],
	casino: { forbiddenCause: "", mensualiteCasino: {} },
};

PaymentModesFieldset.propTypes = {
	creditCardNumber: PropTypes.string,
	paymentModes: PropTypes.arrayOf(PropTypes.number),
	total: PropTypes.number,
	field: PropTypes.object,
	onChange: PropTypes.func,
	casino: PropTypes.object,
	mensualite2Fois: PropTypes.shape({
		percentagePayNow: PropTypes.number,
		payLaterAmount: PropTypes.number,
		payNowAmount: PropTypes.number,
		dueDate: PropTypes.number,
	}),
	isDepositEnabled: PropTypes.bool,
	isBookingEligibleForDeposit: PropTypes.bool,
	isPaiementPledg4xAvailable: PropTypes.bool,
	shop: PropTypes.string,
};

export default PaymentModesFieldset;
